import { OnInit } from '@angular/core';
var VardhanaWalletComponent = /** @class */ (function () {
    function VardhanaWalletComponent() {
    }
    VardhanaWalletComponent.prototype.ngOnInit = function () {
    };
    return VardhanaWalletComponent;
}());
export { VardhanaWalletComponent };
